<template>
  <div>
    <div class="container">
      <jumbotron />
      <user-articles />
      <new-articles />
      <articles-on-sales />
    </div>

    <highlihgted-categories />

    <div class="container">
      <home-banner />
    </div>

    <mobile-app />
    <top-brands />

    <div
      v-if="isCustomDialogVisible"
      class="home-custom-dialog"
      role="dialog"
      aria-modal="true"
      aria-label="Sajam"
      @click.self="closeCustomDialog"
    >
      <div class="home-custom-dialog__image-wrap">
        <button
          type="button"
          class="home-custom-dialog__close"
          aria-label="Close dialog"
          @click="closeCustomDialog"
        >
          <span class="home-custom-dialog__close-icon">&times;</span>
        </button>

        <img
          class="home-custom-dialog__image"
          src="/assets/images/banners/sajam.png"
          alt="Sajam"
        >
      </div>
    </div>
  </div>
</template>

<script>
import UserArticles from './UserArticles.vue';
import NewArticles from './NewArticles.vue';
import Jumbotron from './Jumbotron.vue';
import HighlihgtedCategories from './HighlihgtedCategories.vue';
import ArticlesOnSales from './ArticlesOnSales.vue';
import HomeBanner from './HomeBanner.vue';
import TopBrands from './TopBrands.vue';
import MobileApp from './MobileApp.vue';

export default {
  name: 'Dashboard',
  components: {
    UserArticles,
    NewArticles,
    Jumbotron,
    HighlihgtedCategories,
    ArticlesOnSales,
    HomeBanner,
    TopBrands,
    MobileApp,
  },
  data() {
    return {
      isCustomDialogVisible: false,
      previousBodyOverflow: '',
    };
  },
  // mounted() {
  //   this.$store.dispatch('getAttributes', { retrieveAll: true });
  // },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.addEventListener('keydown', this.handleCustomDialogKeydown);
    this.openSajamDialog();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleCustomDialogKeydown);
    this.unlockBodyScroll();
  },
  methods: {
    openSajamDialog() {
      if (this.isCustomDialogVisible) return;

      this.previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.isCustomDialogVisible = true;
    },
    closeCustomDialog() {
      this.isCustomDialogVisible = false;
      this.unlockBodyScroll();
    },
    unlockBodyScroll() {
      document.body.style.overflow = this.previousBodyOverflow;
    },
    handleCustomDialogKeydown(event) {
      if (event.key === 'Escape' && this.isCustomDialogVisible) {
        this.closeCustomDialog();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-custom-dialog {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.72);
}

.home-custom-dialog__image-wrap {
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  width: 400px;
  height: 500px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 40px);
  line-height: 0;
}

.home-custom-dialog__close {
  position: absolute;
  top: 6px;
  right: 10px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.65);
}

.home-custom-dialog__close-icon {
  display: block;
  font-size: 42px;
  font-weight: 400;
  line-height: 1;
}

.home-custom-dialog__image {
  display: block;
  width: 400px;
  height: 500px;
  max-width: 100%;
  max-height: 100%;
}

@media (max-width: 767px) {
  .home-custom-dialog {
    padding: 12px;
  }

  .home-custom-dialog__close {
    top: 8px;
    right: 10px;
    width: 40px;
    height: 40px;
  }

  .home-custom-dialog__close-icon {
    font-size: 34px;
  }

  .home-custom-dialog__image {
    width: 100%;
    height: 100%;
  }
}
</style>
